<template>
    <div class="settings">
        <Settings />
    </div>
</template>

<script>
// @ is an alias to /src

import Settings from "@/components/Settings.vue";
import { useRouter } from "vue-router";
import { onMounted } from "vue";

export default {
    name: "SettingsView",
    components: {
        Settings,
    },
    setup(props) {
        const router = useRouter();

        onMounted(() => {});

        return {};
    },
};
</script>
